import type { ComponentMessages } from '../types';

const messages: ComponentMessages = {
  'component.securityScheme.formItemName.authorizationType': '鉴权方式',
  'component.securityScheme.apiKeyFormItem.name.label': '名称',
  'component.securityScheme.allowedSecuritySchemes': '可选用的鉴权组件',
  'component.securityScheme.preview.title': '鉴权组件',
  'component.securityScheme.optional': '将鉴权设置为可选项',
  'component.securityScheme.inheritFrom': '从父级目录继承',
  'component.securityScheme.noAuthDesc': '无需鉴权',
  'component.securityScheme.useCase.empty-alert':
    '该接口引用的鉴权组件已被删除，请修改该接口的鉴权配置。',
} as const;

export default messages;
